/* eslint-disable react/prop-types */
import './style.scss';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from 'react-query';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import {
  getGeneralProjectProposalInfo,
  getReviewerInfo,
  downloadPdfTemplate,
  downloadDocxTemplate,
  downloadDocxFile,
  downloadPdfFile,
  submit as submitMidtermReview,
} from 'apis/midtermReviews.api';

import ErrorDialog from 'components/ErrorDialog';
import { HugerteEditor, Tickbox } from 'components/FormControl';
import Loading from 'components/Loading';

import { TOAST } from 'constant';
import { toast } from 'layout';

// import { useForm, useFormState } from 'react-hook-form';

// import { isMemberAllowedReview } from 'utils/func';
// eslint-disable-next-line import/no-cycle, import/named
// eslint-disable-next-line import/no-cycle
import Signature from 'features/PrequalificationReview/components/Signature';
// eslint-disable-next-line import/no-cycle
import { DetailInfo, EvaluationForm } from '..';

export default function Detail({
  isLoadingCreate,
  isErrorRes,
  errorRes,
  control,
  setValue,
  getValues,
  // isDirty,
  // dirtyFields,
  reset,
  errors,
  // isValid,
  isVisibleErrorDialog,
  setIsVisibleDialogError,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { projectProposalId } = useParams();
  const [searchParams] = useSearchParams();
  const councilId = searchParams.get('councilId');
  const councilMemberId = searchParams.get('councilMemberId');
  const userId = searchParams.get('userId');
  const downloadButtonRef = useRef();
  const downloadTemplateButtonRef = useRef();
  const [isVisibleSubmitDialog, setIsVisibleSubmitDialog] = useState(false);

  // #region Data
  // general info projectProposal
  const { data: dataGeneralProjectProposalInfo, isLoading: isLoadingProjectProposal } = useQuery(
    ['midterm-review', 'project-proposal', councilId, projectProposalId],
    ({ queryKey: [, , _councilId, _projectProposalId] }) =>
      getGeneralProjectProposalInfo(_councilId, _projectProposalId, _projectProposalId)
  );
  const generalProjectProposalInfo = useMemo(
    () => dataGeneralProjectProposalInfo?.data,
    [dataGeneralProjectProposalInfo]
  );

  // reviewer info
  const {
    data: dataReviewerInfo,
    isLoading: isLoadingReviewer,
    refetch: refetchReviewerInfo,
  } = useQuery(
    ['midterm-review', 'reviewer', userId, councilId, projectProposalId],
    ({ queryKey: [, , _userId, _councilId, _projectProposalId] }) =>
      getReviewerInfo(_userId, _councilId, _projectProposalId)
  );
  const reviewerInfo = useMemo(() => dataReviewerInfo?.data, [dataReviewerInfo]);

  // #end region Data

  const [requestState, setRequestState] = useState({ requestStop: false, requestContinue: false });

  const onIngredientsChange = (name) => {
    if (name === 'requestStop') {
      setRequestState({ requestStop: true, requestContinue: false });
    } else {
      setRequestState({ requestStop: false, requestContinue: true });
    }
  };

  useEffect(() => {
    setValue('requestStop', requestState.requestStop);
    setValue('requestContinue', requestState.requestContinue);
  }, [requestState]);
  // doan code nay danh cho C. ket luan
  // #region Events
  const {
    mutate: mutateSubmit,
    error: errorSubmit,
    isError: isErrorSubmit,
  } = useMutation(submitMidtermReview);

  const onConfirmSubmit = () => {
    const submitData = {
      projectProposalId,
      councilId,
      councilMemberId,
    };

    mutateSubmit(submitData, {
      onSuccess: () => {
        reset({}, { keepValues: true });
        toast(TOAST.SUCCESS, t('council.review.updateSuccess'));
        setIsVisibleSubmitDialog(false);
        setTimeout(() => {
          navigate('/project-proposal-defense');
        }, 1500);
      },
      onError: () => {
        setIsVisibleDialogError(true);
      },
    });
  };

  const footerConfirmSubmit = () => (
    <div>
      <Button
        label={t('formLayout.action.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => setIsVisibleSubmitDialog(false)}
        autoFocus
      />
      <Button
        label={t('formLayout.action.ok')}
        className="w-7rem"
        severity="info"
        onClick={onConfirmSubmit}
      />
    </div>
  );
  // const checkValidation = () => {
  //   if (!isValid) {
  //     toast(TOAST.ERROR, t('errorMessage.validationErrorMessage'));
  //   }
  // };

  const {
    refetch: handleDownloadPdfFile,
    isLoading: isDownloadPdfFileLoading,
    isFetching: isDownloadPdfFileFetching,
  } = useQuery(
    ['downloadPdfFileMidtermReview', projectProposalId, councilId, councilMemberId],
    () =>
      downloadPdfFile({
        projectProposalId,
        referenceId: projectProposalId,
        councilId,
        councilMemberId,
      }),
    {
      enabled: false,
      onSuccess: (res) => {
        if (res?.data) {
          const file = new Blob([res.data]);

          const filename = 'Phieu nhan xet danh gia giua ky.pdf';

          const link = document.createElement('a');
          link.href = URL.createObjectURL(file);
          link.download = filename;
          link.click();
        }
      },
      onError: () => {
        toast(TOAST.ERROR, t('projectProposal.review.exportPdfErrorTitle'));
      },
    }
  );

  const {
    refetch: handleDownloadDocxFile,
    isLoading: isDownloadDocxFileLoading,
    isFetching: isDownloadDocxFileFetching,
  } = useQuery(
    ['downloadDocxFileMidtermReview', projectProposalId, councilId, councilMemberId],
    () =>
      downloadDocxFile({
        projectProposalId,
        referenceId: projectProposalId,
        councilId,
        councilMemberId,
      }),
    {
      enabled: false,
      onSuccess: (res) => {
        if (res?.data) {
          const file = new Blob([res.data]);

          const filename = 'Phieu nhan xet danh gia giua ky.docx';

          const link = document.createElement('a');
          link.href = URL.createObjectURL(file);
          link.download = filename;
          link.click();
        }
      },
      onError: () => {
        toast(TOAST.ERROR, t('projectProposal.review.exportDocxErrorTitle'));
      },
    }
  );

  const {
    refetch: handleDownloadPdfTemplate,
    isLoading: isDownloadPdfTemplateLoading,
    isFetching: isDownloadPdfTemplateFetching,
  } = useQuery(
    ['downloadPdfTemplateMidtermReview', projectProposalId, councilId, councilMemberId],
    () =>
      downloadPdfTemplate({
        projectProposalId,
        referenceId: projectProposalId,
        councilId,
        councilMemberId,
      }),
    {
      enabled: false,
      onSuccess: (res) => {
        if (res?.data) {
          const file = new Blob([res.data]);

          const filename = 'Mau M06 - Phieu nhan xet danh gia giua ky.pdf';

          const link = document.createElement('a');
          link.href = URL.createObjectURL(file);
          link.download = filename;
          link.click();
        }
      },
      onError: () => {
        toast(TOAST.ERROR, t('projectProposal.review.exportPdfErrorTitle'));
      },
    }
  );

  const {
    refetch: handleDownloadDocxTemplate,
    isLoading: isDownloadDocxTemplateLoading,
    isFetching: isDownloadDocxTemplateFetching,
  } = useQuery(
    ['downloadDocxTemplateMidtermReview', projectProposalId, councilId, councilMemberId],
    () =>
      downloadDocxTemplate({
        projectProposalId,
        referenceId: projectProposalId,
        councilId,
        councilMemberId,
      }),
    {
      enabled: false,
      onSuccess: (res) => {
        if (res?.data) {
          const file = new Blob([res.data]);

          const filename = 'Mau M06 - Phieu nhan xet danh gia giua ky.docx';

          const link = document.createElement('a');
          link.href = URL.createObjectURL(file);
          link.download = filename;
          link.click();
        }
      },
      onError: () => {
        toast(TOAST.ERROR, t('projectProposal.review.exportDocxErrorTitle'));
      },
    }
  );

  return (
    <div className="bg-white p-5">
      {(isLoadingCreate || isLoadingReviewer || isLoadingProjectProposal) && <Loading />}
      {isErrorRes && (
        <ErrorDialog
          title={t('council.review.create')}
          isError={isErrorRes}
          error={errorRes}
          visible={isVisibleErrorDialog}
          setVisible={setIsVisibleDialogError}
        />
      )}

      {isErrorSubmit && (
        <ErrorDialog
          title={t('council.review.submit')}
          isError={isErrorSubmit}
          error={errorSubmit}
          visible={isVisibleErrorDialog}
          setVisible={setIsVisibleDialogError}
        />
      )}

      <div className="flex justify-content-end">
        <Button
          label={t('council.review.exportFile')}
          icon={`pi ${
            isDownloadPdfFileLoading ||
            isDownloadPdfFileFetching ||
            isDownloadDocxFileLoading ||
            isDownloadDocxFileFetching
              ? 'pi-spin pi-spinner'
              : 'pi-file'
          }`}
          className="block w-auto h-3rem border-none"
          severity="info"
          onClick={(event) => downloadButtonRef.current.toggle(event)}
          disabled={
            isDownloadPdfFileLoading ||
            isDownloadPdfFileFetching ||
            isDownloadDocxFileLoading ||
            isDownloadDocxFileFetching
          }
        />
        <Button
          // type="button"
          label={t('council.review.downloadTemplate')}
          icon={`pi ${
            isDownloadPdfTemplateLoading ||
            isDownloadPdfTemplateFetching ||
            isDownloadDocxTemplateLoading ||
            isDownloadDocxTemplateFetching
              ? 'pi-spin pi-spinner'
              : 'pi-file'
          }`}
          className="block w-auto h-3rem border-none ml-1"
          severity="info"
          onClick={(event) => downloadTemplateButtonRef.current.toggle(event)}
          disabled={
            isDownloadPdfTemplateLoading ||
            isDownloadPdfTemplateFetching ||
            isDownloadDocxTemplateLoading ||
            isDownloadDocxTemplateFetching
          }
        />
      </div>

      <Menu
        ref={downloadButtonRef}
        model={[
          {
            label: t('council.review.exportPdf'),
            icon: 'pi pi-file-pdf',
            command: handleDownloadPdfFile,
            disabled: isDownloadPdfFileLoading || isDownloadPdfFileFetching,
          },
          {
            label: t('council.review.exportDocx'),
            icon: 'pi pi-file-word',
            command: handleDownloadDocxFile,
            disabled: isDownloadDocxFileLoading || isDownloadDocxFileFetching,
          },
        ]}
        popup
      />
      <Menu
        ref={downloadTemplateButtonRef}
        model={[
          {
            label: t('council.review.downloadPdfTemplate'),
            icon: 'pi pi-file-pdf',
            command: handleDownloadPdfTemplate,
            disabled: isDownloadPdfTemplateLoading || isDownloadPdfTemplateFetching,
          },
          {
            label: t('council.review.downloadDocxTemplate'),
            icon: 'pi pi-file-word',
            command: handleDownloadDocxTemplate,
            disabled: isDownloadDocxTemplateLoading || isDownloadDocxTemplateFetching,
          },
        ]}
        popup
      />
      <Dialog
        visible={isVisibleSubmitDialog}
        header={<p className="text-blue-500">{t('council.submit.confirmationTitle')}</p>}
        position="center"
        style={{ width: '410px' }}
        onHide={() => setIsVisibleSubmitDialog(false)}
        footer={() => footerConfirmSubmit()}
      >
        <p className="text-lg py-3">{t('council.submit.confirmationSubmitMessage')}</p>
      </Dialog>
      <div className="p-fluid specialize-review-create">
        <div className="m-0 bg-white p-5 p-fluid">
          <h3 className="mb-5 text-4xl text-center">
            <span className="line-height-3 font-semibold">{t('council.m06.title')} </span>
            <br />
            <span className="font-normal">{t('council.m06.sciTechProject')}</span>
          </h3>
        </div>
        <DetailInfo
          generalProjectProposalInfo={generalProjectProposalInfo}
          reviewerInfo={reviewerInfo}
        />
        <form autoComplete="off">
          <div className="mx-8 relative">
            <h4>{t('council.m06.a.label')}</h4>
            <h5>
              {t('council.m06.a.a1')}
              <span className="text-red-500" style={{ fontWeight: 900 }}>
                {' '}
                *
              </span>
            </h5>
            <div className="mt-3">
              <HugerteEditor name="reviewResearchPlan" control={control} errors={errors} />
            </div>
            <h5>
              {t('council.m06.a.a2')}
              <span className="text-red-500" style={{ fontWeight: 900 }}>
                {' '}
                *
              </span>
            </h5>
            <div className="mt-3">
              <HugerteEditor name="reviewProduct" isRequired control={control} errors={errors} />
            </div>
            <h5>
              {t('council.m06.a.a3')}
              <span className="text-red-500" style={{ fontWeight: 900 }}>
                {' '}
                *
              </span>
            </h5>
            <div className="mt-3">
              <HugerteEditor name="reviewProgress" isRequired control={control} errors={errors} />
            </div>
            <h5>
              {t('council.m06.a.a4')}
              <span className="text-red-500" style={{ fontWeight: 900 }}>
                {' '}
                *
              </span>
            </h5>
            <div className="mt-3">
              <HugerteEditor
                name="reviewExpenditureUsed"
                isRequired
                control={control}
                errors={errors}
              />
            </div>
            <h5>
              {t('council.m06.a.a5')}
              <span className="text-red-500" style={{ fontWeight: 900 }}>
                {' '}
                *
              </span>
            </h5>
            <div className="mt-3">
              <HugerteEditor
                name="reviewContinueAbility"
                isRequired
                control={control}
                errors={errors}
              />
            </div>
            <h5>
              {t('council.m06.a.a6')}
              <span className="text-red-500" style={{ fontWeight: 900 }}>
                {' '}
                *
              </span>
            </h5>
            <div className="mt-3">
              <HugerteEditor name="otherReview" isRequired control={control} errors={errors} />
            </div>
            <h5>
              {/* {t('council.m01.a.a4.label')} */}
              {/* <span className="text-red-500" style={{ fontWeight: 900 }}>
                {' '}
                *
              </span> */}
            </h5>

            <h5>
              {t('council.m06.b.lable')}
              {/* <span className="text-red-500" style={{ fontWeight: 900 }}>
                {' '}
                *
              </span> */}
            </h5>
            <EvaluationForm
              setValue={setValue}
              getValues={getValues}
              control={control}
              errors={errors}
            />
            <h5>
              {t('council.m06.c.conclusion')}{' '}
              {/* <span className="text-red-500" style={{ fontWeight: 900 }}>
                {' '}
                *
              </span> */}
            </h5>

            {/* C */}
            <div className="flex flex-column justify-content-center gap-2">
              <div className="flex align-items-center">
                <Tickbox
                  icon="pi pi-check"
                  name="requestStop"
                  control={control}
                  errors={errors}
                  onCustomCheck={onIngredientsChange}
                />
                <label htmlFor="ingredient1" className="ml-2">
                  {t('council.m06.c.stop')}
                </label>
              </div>
              <label htmlFor="ingredient1" className="ml-2 mt-2">
                {t('council.m06.c.reason')}
              </label>
              <div className="mt-3">
                <HugerteEditor
                  name="requestStopReason"
                  isRequired
                  control={control}
                  errors={errors}
                />
              </div>
              <div className="flex align-items-center">
                <Tickbox
                  icon="pi pi-check"
                  name="requestContinue"
                  control={control}
                  errors={errors}
                  onCustomCheck={onIngredientsChange}
                />
                <label htmlFor="ingredient2" className="ml-2">
                  {t('council.m06.c.continute')}
                </label>
              </div>
              <div className="mt-3">
                <HugerteEditor
                  name="requestContinueModify"
                  isRequired
                  control={control}
                  errors={errors}
                />
              </div>
            </div>

            {/* // Day la footer */}
            <div className="grid text-lg mt-8">
              <div className="col-7 px-8">
                <span>{t('council.m01.c.commitment')}</span>
              </div>
              <div className="col-5 text-center">
                <Signature
                  refetchReviewerInfo={refetchReviewerInfo}
                  reviewerInfo={reviewerInfo}
                  readOnly
                />
              </div>
            </div>

            <div className="flex justify-content-end mt-8">
              <Button
                label={t('formLayout.action.close')}
                severity="danger"
                type="button"
                onClick={() => navigate(-1)}
                className="mr-2 w-8rem"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

Detail.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  isLoadingCreate: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  isErrorRes: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/require-default-props
  errorRes: PropTypes.shape({}),
  control: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  watch: PropTypes.func,
  reset: PropTypes.func.isRequired,
  // setValue: PropTypes.func.isRequired,
  // getValues: PropTypes.func.isRequired,
  // isDirty: PropTypes.bool.isRequired,
  dirtyFields: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  // isValid: PropTypes.bool.isRequired,
  isVisibleErrorDialog: PropTypes.bool.isRequired,
  setIsVisibleDialogError: PropTypes.func.isRequired,
};

Detail.defaultProps = {
  watch: null,
};
